<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row mb-3">
            <div class="col-12">
                <div class="btn-group" role="group">
                    <button type="button" class="btn" [class.btn-primary]="isCreateMode" (click)="setMode('create')">
                        Create new work order
                    </button>
                    <button type="button" class="btn" [class.btn-outline-primary]="isCreateMode" [class.btn-primary]="!isCreateMode" (click)="setMode('addExisting')">
                        Add to existing WebApps WO
                    </button>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-6">
                <div class="form-group mb-3">
                    <label for="equipment">Equipment</label>
                    <wj-combo-box
                        id="equipment"
                        [(ngModel)]="equipment"
                        (ngModelChange)="onEquipmentChanged()"
                        name="equipment"
                        [itemsSource]="equipmentOptions"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="true"
                    ></wj-combo-box>
                </div>
            </div>
            @if (isCreateMode) {
                <div class="col-md-6">
                    <div class="form-group mb-3">
                        <label for="job">Job</label>
                        <wj-combo-box
                            id="job"
                            [(ngModel)]="job"
                            name="job"
                            [itemsSource]="jobOptions"
                            [displayMemberPath]="'display'"
                            [selectedValuePath]="'value'"
                            [isRequired]="false"
                        ></wj-combo-box>
                    </div>
                </div>
            }
        </div>

        @if (!isCreateMode) {
            <div class="row">
                <div class="col-12">
                    <div class="form-group mb-3">
                        <label for="selectedWorkOrderId">Open WebApps work order</label>
                        <wj-combo-box
                            id="selectedWorkOrderId"
                            [(ngModel)]="selectedWorkOrderId"
                            name="selectedWorkOrderId"
                            [itemsSource]="openWorkOrderOptions"
                            [displayMemberPath]="'display'"
                            [selectedValuePath]="'value'"
                            [isRequired]="true"
                        ></wj-combo-box>
                    </div>
                </div>
            </div>
        }

        <div class="row">
            <div class="col-12">
                <div class="form-group mb-3">
                    <label for="description">Description</label>
                    <textarea
                        id="description"
                        class="form-control"
                        rows="3"
                        [(ngModel)]="description"
                        name="description"
                        required
                    ></textarea>
                </div>
            </div>
        </div>

        @if (isCreateMode) {
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group mb-3">
                        <label for="systemAffected">System affected</label>
                        <wj-combo-box
                            id="systemAffected"
                            [(ngModel)]="systemAffected"
                            (ngModelChange)="onSystemAffectedChanged()"
                            name="systemAffected"
                            [itemsSource]="skillCategoryOptions"
                            [displayMemberPath]="'display'"
                            [selectedValuePath]="'value'"
                            [isRequired]="true"
                        ></wj-combo-box>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group mb-3">
                        <label for="assignedMechanicHrRef">Assign mechanic</label>
                        <wj-combo-box
                            id="assignedMechanicHrRef"
                            [(ngModel)]="assignedMechanicHrRef"
                            name="assignedMechanicHrRef"
                            [itemsSource]="mechanicOptions"
                            [displayMemberPath]="'display'"
                            [selectedValuePath]="'value'"
                            [isRequired]="false"
                        ></wj-combo-box>
                    </div>
                </div>
            </div>
        }

        <div class="row">
            <div class="col-12">
                <div class="form-group mb-3">
                    <label for="notes">Notes</label>
                    <textarea id="notes" class="form-control" rows="2" [(ngModel)]="notes" name="notes"></textarea>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
